export enum UserActionTypes {
    API_RESPONSE_SUCCESS = '@@user/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@user/API_RESPONSE_ERROR',

    GET_USERS = '@@user/GET_USERS',
    GET_USER_DETAILS = '@@user/GET_USER_DETAILS',
    UPDATE_USER = '@@user/UPDATE_USER',
    ADD_USER = '@@user/ADD_USER',
    DELETE_USER = '@@user/DELETE_USER',
    GET_DASHBOARD_DATA = '@@user/GET_DASHBOARD_DATA',
}
